import { IoCloseOutline } from "react-icons/io5";
import InputComponent from "components/InputG";
import CheckboxComponent from "components/CheckBoxG";
import { useEffect, useState } from "react";
import SelectAutoComplete from "components/selectAutoCompleteG";
import { useListarUsuariosCorretores } from "services/api/Identity_Usuario/listar-usuarios-corretores";
import { useAprovacaoComercial } from "services/api/AppWeb_Oportunidade/aprovacao-comercial-put";
import MaterialUI from "material-UI";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import RadioComponent from "components/RadioG";
import { useImobiliarias } from "services/api/AppWeb_Oportunidade/get-imobiliarias";
import { useAutonomos } from "services/api/AppWeb_Oportunidade/get-autonomos";
import { useParams } from "react-router-dom";
import { useListarUsuariosCorretoresFifty } from "services/api/Identity_Usuario/listar-corretores-fifty";
import * as S from "./styles";

interface Data {
  onClose: () => void;
  dataDetalheOportunidade: any;
  refetchDetalheOportunidade: () => void;
  refetchHistorico: () => void;
}

enum R {
  imob = "1",
  aut = "2",
}

const ModalAprovacao = (data: Data) => {
  const { idsBandeiras } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const [checkedClienteMesa, setCheckedClienteMesa] = useState(false);
  const [corretorFifty, setCorretorFifty] = useState({ value: "", label: "" });
  const [imobAut, setImobAut] = useState<R>(R.imob);
  const [cia, setCia] = useState({
    _: { value: "", label: "" },
  });

  const params: any = useParams();

  const { data: dataCorretores, refetch: refetchCorretores } =
    useListarUsuariosCorretoresFifty({
      queryKey: "listar-corretores-equipe-aprovacao-fifty",
      idsBandeiras: idsBandeiras || [],
    });

  const { usuarioCia } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const { data: dataImob, refetch: refetchImob } = useImobiliarias();
  const { data: dataAut, refetch: refetchAut } = useAutonomos();

  const dataImobMap = dataImob?.imobiliarias?.map((item: any) => ({
    value: item.id,
    label: item.nome,
    apelido: item.apelido,
    cnpj: item.cnpj,
    email: item.email,
    creci: item.creci,
  }));

  const dataAutMap = dataAut?.autonomos?.map((item: any) => ({
    value: item.id,
    label: item.nomeCompleto,
    cpf: item.cnpj,
    email: item.email,
    creci: item.creci,
  }));

  useEffect(() => {
    if (usuarioCia) {
      refetchImob();
      refetchAut();
    }
  }, []);

  const {
    mutate: mutateAprovarComercial,
    isSuccess: isSuccessAprovarComercial,
    isLoading: isLoadingAprovarComercial,
  } = useAprovacaoComercial({
    clienteNaMesa: checkedClienteMesa,
    idCorretorFifty: corretorFifty?.value,
    idLeadCorretor: params.idLeadCorretor,
    idCorretorLead: data.dataDetalheOportunidade?.idCorretor365,
    idOportunidade: data.dataDetalheOportunidade?.idOportunidade,
    nomeCorretorFifty: corretorFifty?.label,
    autonomo: imobAut === R.aut,
    imobiliaria: imobAut === R.imob,
    nomeAutonomo: cia._?.label,
    nomeImobiliaria: cia._?.label,
  });

  useEffect(() => {
    if (dataCorretores?.data === undefined) {
      refetchCorretores();
    }
  }, []);

  useEffect(() => {
    if (isSuccessAprovarComercial) {
      data.refetchDetalheOportunidade();
      data.refetchHistorico();
      data.onClose();
    }
  }, [isSuccessAprovarComercial]);

  const handleSubmit = () => {
    mutateAprovarComercial();
  };

  return (
    <S.Content>
      <S.Header>
        <S.Row style={{ justifyContent: "space-between" }}>
          <S.TextTitle>Aprovação comercial</S.TextTitle>
          <S.CloseButton onClick={data.onClose}>
            <IoCloseOutline size={32} />
          </S.CloseButton>
        </S.Row>
      </S.Header>
      <S.SpaceY space={20} />
      <S.Body>
        {usuarioCia ? (
          <>
            <S.TextPagamentoSinal>
              Imobiliária ou autônomo?
            </S.TextPagamentoSinal>
            <S.SpaceY space={10} />
            <S.Row style={{ gap: 8 }}>
              <S.Row>
                <RadioComponent
                  value={R.imob}
                  label="Imobiliária"
                  checked={imobAut === R.imob}
                  onChange={(e) => {
                    setImobAut(e.target.value as R);
                    setCia((prev) => ({
                      ...prev,
                      _: { value: "", label: "" },
                    }));
                  }}
                />
                <RadioComponent
                  value={R.aut}
                  label="Autônomo"
                  checked={imobAut === R.aut}
                  onChange={(e) => {
                    setImobAut(e.target.value as R);
                    setCia((prev) => ({
                      ...prev,
                      _: { value: "", label: "" },
                    }));
                  }}
                />
              </S.Row>
            </S.Row>
            <S.SpaceY space={20} />
            <S.Row style={{ gap: 20 }}>
              <SelectAutoComplete
                data={imobAut === R.imob ? dataImobMap || [] : dataAutMap || []}
                placeholder="Selecione"
                label={imobAut === R.imob ? "Imobiliária" : "Autônomo"}
                borderRadius="8px"
                value={cia._}
                onChange={(e: { value: string; label: string }) => {
                  setCia((prev) => ({ ...prev, _: e }));
                }}
              />
            </S.Row>
            <S.SpaceY space={20} />
          </>
        ) : (
          <></>
        )}
        <InputComponent
          label="Corretor"
          value={data.dataDetalheOportunidade?.nomeCorretor}
          disabled
          onChange={() => {}}
          width="100%"
          borderRadius="8px"
        />
        <S.SpaceY space={20} />
        <SelectAutoComplete
          data={
            dataCorretores?.data.map((item: any) => ({
              value: item?.idCorretor,
              label: item?.apelido,
            })) || []
          }
          label="Corretor Fifty"
          borderRadius="8px"
          value={corretorFifty}
          onChange={(e: { value: string; label: string }) => {
            setCorretorFifty(e);
          }}
        />
        <S.SpaceY space={5} />
        <CheckboxComponent
          label="Cliente na mesa"
          checked={checkedClienteMesa}
          onChange={() => setCheckedClienteMesa(!checkedClienteMesa)}
          color="#2D5BFF"
        />
        <S.SpaceY space={20} />
        <S.Row style={{ gap: 16 }}>
          <S.CancelButton onClick={data.onClose}>Cancelar</S.CancelButton>
          <S.SendButton
            onClick={() => {
              handleSubmit();
            }}
            disabled={isLoadingAprovarComercial}
          >
            {isLoadingAprovarComercial ? (
              <MaterialUI.CircularProgress
                size={22}
                style={{ color: "#ffffff" }}
              />
            ) : (
              "Enviar"
            )}
          </S.SendButton>
        </S.Row>
      </S.Body>
    </S.Content>
  );
};

export default ModalAprovacao;
